import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';
import {
  cardV2Body,
  cardV2Description,
  cardV2Footer,
  cardV2FooterContent,
  cardV2FooterRule,
  cardV2Header,
  cardV2Hoverable,
  cardV2Root,
  cardV2Title,
} from './card-v2.css.ts';

export const CardV2 = ({
  className,
  hoverable,
  ...rest
}: ComponentPropsWithoutRef<'div'> & { hoverable?: boolean }) => (
  <div
    className={clsx(cardV2Root, hoverable && cardV2Hoverable, className)}
    {...rest}
  />
);

export const CardV2Header = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<'div'>) => (
  <div className={clsx(cardV2Header, className)} {...rest} />
);

export const CardV2Body = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<'div'>) => (
  <div className={clsx(cardV2Body, className)} {...rest} />
);

export const CardV2Footer = ({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<'div'>) => (
  <div className={clsx(cardV2Footer, className)} {...rest}>
    <hr className={cardV2FooterRule} />
    <div className={cardV2FooterContent}>{children}</div>
  </div>
);

export const CardV2Title = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<'p'>) => (
  <p className={clsx(cardV2Title, className)} {...rest} />
);

export const CardV2Description = ({
  className,
  ...rest
}: ComponentPropsWithoutRef<'p'>) => (
  <p className={clsx(cardV2Description, className)} {...rest} />
);
